import type { Dispatch, SetStateAction } from 'react';
import { useEffect } from 'react';

import { useCart } from '@order/hooks';

import type { CheckoutPayload } from '../../Checkout.utils';
import { calculateTip } from '../../Checkout.utils';

// Synchronized the delivery order details with the checkout payload.
export const useSyncDeliveryOrderDetails = ({
  addressId,
  setPayload,
}: SyncDeliveryOrderDetailsProps) => {
  const { cart } = useCart();

  useEffect(() => {
    setPayload((previous) => ({
      ...previous,
      deliveryOrderDetail: addressId
        ? {
            addressId,
            tip: calculateTip(cart?.ledger?.subtotal),
            deliveryFee: cart?.deliveryOrderDetail?.deliveryFee ?? 0,
            vendor: cart?.deliveryOrderDetail?.vendor ?? '',
            vendorRestaurantId:
              cart?.deliveryOrderDetail?.vendorRestaurantId ?? '',
          }
        : undefined,
    }));
  }, [addressId, cart, setPayload]);
};

// ───── Types ──────────────────────────────────────────────────────

type SyncDeliveryOrderDetailsProps = {
  readonly addressId?: string;
  readonly setPayload: Dispatch<SetStateAction<CheckoutPayload>>;
};
